
import Company from './company'
import Meeting from './meeting'
import Persona from './persona'

export default {
  components: {Company, Meeting, Persona},
  props: {
    cards: {type: Array, required: true},
    loading: {type: Boolean, default: false},
    readonly: {type: Boolean, default: false}
  },
}
